var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"full-page d-flex",class:_vm.customClass},[_c('div',{staticClass:"max-width"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }